import { Component } from '@angular/core';
import { HomeComponent as HomeComponentV1 } from '../../app/home/home.component'
@Component({
    selector: 'gol-home',
    templateUrl: '../../app/home/home.component.html',
    styleUrls: ['../../app/home/home.component.css', '../../app/home/slider.css']
})
export class HomeComponent extends HomeComponentV1 {
}
